// extracted by mini-css-extract-plugin
export var productImage = "_zt-0";